import { LandingTitle, PageLayout } from "../../components/index";
import { images } from "../../utils/images";
import LocationList from "./locationList/LocationList";
import {Helmet} from "react-helmet";
const Location = () => {
  return (
    <PageLayout>
         <Helmet>
        <title>Locations | Exotic Group</title>
        <meta name="description" content="Locations | Exotic Group" />
      </Helmet>
      <LandingTitle
        bgImage={images.galleryLanding}
        title="Locations"
        para="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nemo odio id, necessitatibus beatae veniam distinctio perferendis."
      />
      <LocationList />
    </PageLayout>
  );
};

export default Location;
